import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Skeleton from 'react-loading-skeleton';

import { getMatchingContacts } from '../../../../services/browseService';

import MatchingContactCard from './MatchingContactCard';

const MatchingContactsList = ({ jobId, opening }) => {
  const { t } = useTranslation('common');
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!jobId) {
      setLoading(false);
      return;
    }

    let cancelled = false;
    setLoading(true);
    setError(null);

    getMatchingContacts(jobId, { limit: 3, include_reasons: true })
      .then((response) => {
        if (cancelled) return;
        const payload = response.data?.payload || response.data;
        setContacts(payload.contacts || []);
      })
      .catch((err) => {
        if (cancelled) return;
        setError(err);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [jobId]);

  const title = (
    <p className="text-base font-semibold text-gray-900 mb-3">
      {t('browse.recommendationsTitle')}
    </p>
  );

  if (loading) {
    return (
      <div>
        {title}
        <div className="space-y-3">
          {[...Array(3)].map((_, i) => (
            <div key={`skeleton-${i}`} className="rounded-lg border border-gray-200 p-3">
              <div className="flex gap-3">
                <Skeleton circle width={40} height={40} />
                <div className="flex-grow">
                  <Skeleton width="60%" height={14} className="mb-2" />
                  <Skeleton width="40%" height={12} className="mb-1" />
                  <Skeleton width="30%" height={12} />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div>
        {title}
        <div className="flex items-center justify-center p-6 text-center">
          <p className="text-sm text-gray-500">{t('browse.recommendationsError')}</p>
        </div>
      </div>
    );
  }

  if (contacts.length === 0) {
    return (
      <div>
        {title}
        <div className="flex items-center justify-center p-6 text-center">
          <p className="text-sm text-gray-500">{t('browse.noRecommendations')}</p>
        </div>
      </div>
    );
  }

  return (
    <div>
      {title}
      <div className="space-y-3">
        {contacts.map((item) => (
          <MatchingContactCard
            key={item.contact?.id || item.contact?.user_contact_id}
            contact={item.contact}
            matchingScore={item.matching_score}
            matchingReason={item.matching_reason}
            opening={opening}
          />
        ))}
      </div>
    </div>
  );
};

export default MatchingContactsList;
